import styled from "styled-components";

export const Container = styled.div`
	position: relative;
	margin: 6px;
	margin-bottom: -12px;
`;

